import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { B04aInventoryInfoPage } from '../b04a-inventory-info/b04a-inventory-info';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { B04cInventoryPage } from '../b04c-inventory/b04c-inventory';
import { B04dInventoryLevelInfoPage } from '../b04d-inventory-level-info/b04d-inventory-level-info';
import { B05bPurchaseAddPage } from '../b05b-purchase-add/b05b-purchase-add';

/**
 * Generated class for the B04InventoryManagementPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface inventoryInfo{
  INVENTORY_LEVEL_ID: number;
  INVENTORY_ID: number;
  ITEM_DESC: string;
  COST: number; 
  SELLING_PRICE: number; 
  QUANTITY: number; 
  VALUE: number; 
  INVENTORY_ACTIVE: string;  
  INVENTORY_TYPE_ID: number;
  NAME: string; 
  BRANCH_ID: number;
  BRANCH_NAME: string;
}

interface branchInfo{
  BRANCH_ID: number;
  BRANCH_NAME: string;
}

@IonicPage()
@Component({
  selector: 'page-b04-inventory-management',
  templateUrl: 'b04-inventory-management.html',
})
export class B04InventoryManagementPage {

  loading: any;
  Status: any;
  inventoryArr: inventoryInfo[] = [];
  inventoryItems: inventoryInfo[] = [];
  branchArr: branchInfo[] = [];
  branchItems: branchInfo[] = [];
  public errorMessage: any = "";
  public searchMessage:any ="";
  branch: any = "";
  inventoryDesc:any = "";
  GRP_ID: any;
  BRANCH_ID: any;
  TOTAL_INVENTORY: number = 0;

  constructor(public navCtrl: NavController, public navParams: NavParams,
              public serviceapi: ServiceApiProvider, public loadingCtrl: LoadingController) 
  {

    this.GRP_ID = sessionStorage.getItem('usergroupid');
    this.BRANCH_ID = sessionStorage.getItem('userbranchid');

    let sortby= "BRANCH_ID";
    let sorttype= "DESC";

    let temp_tbl = [];
    let temp_column = [];
    let temp_value = [];

    if(this.GRP_ID=="1") {            //system admin
      temp_tbl = ["All"];
      temp_column = ["All"];
      temp_value = ["All"];
    }
    else if ((this.GRP_ID == "2") || (this.GRP_ID == "3")) {      //corporate admin/ manager
      temp_tbl = ["INVENTORY_LEVEL"]; 
      temp_column = ["BRANCH_ID"];
      temp_value = [this.BRANCH_ID];
    }

    let tbl = temp_tbl;
    let column = temp_column;
    let value = temp_value;
    
    let tblkey = ["BRANCH_ID", "INVENTORY_ID"];
    let fktbl = ["BRANCH", "INVENTORY"];
    let fkkey = ["BRANCH_ID", "INVENTORY_ID"];
  
    let jsonsort = this.serviceapi.sort(sortby,sorttype);
    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonsort,jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();
    
    this.serviceapi.readdata(json_data,"INVENTORY_LEVEL","1","1").then((result) => {
      let rxdata = result["RXData"];
      this.Status = result["Message"];
      if (this.Status == '1'){
        let Records = result["Records"];
        this.inventoryArr = Records;
        this.inventoryItems = this.inventoryArr;

        for (let x=0; x<=((rxdata)-1); x++)                       //sum total value
        {
          this.TOTAL_INVENTORY += +parseFloat(Records[x].VALUE);
        }
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }

      if (this.GRP_ID == "1") {
        let tbl = ["All"];
        let column = ["All"];
        let value = ["All"];
        
        let tblkey = ["No"];
        let fktbl = ["No"];
        let fkkey = ["No"];
      
        let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

        let mydata = Object.assign(jsonitem);
        let json_data = this.serviceapi.json_readdata(mydata,"1");

        this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result) => {
          this.loading.dismiss();
          this.Status = result["Message"];
          if (this.Status == '1'){
            
            let Records = result["Records"];
            this.branchArr = Records;
            this.branchItems = this.branchArr;
          }
          else {
            this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
          }
        }, (err) => {
          this.errorMessage = "Loading Error. Please try again.";
          this.loading.dismiss();
        });
      }
      else{
        this.loading.dismiss();
      }
      
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B04InventoryManagementPage');
  }

  goToEdit(ID){
    this.navCtrl.push(B04dInventoryLevelInfoPage, {paramID: ID, paramEdit: 1});          //Inventory ID
  }

  goToEditQty(ID, inventoryID){
    this.navCtrl.push(B04dInventoryLevelInfoPage, {paramID: ID, paramInventoryID: inventoryID, paramEdit: 2});          //Inventory ID
  }

  goToPurchase(branchid, inventoryID){
    console.log("b"+branchid);
    console.log("in"+inventoryID);
    this.navCtrl.push(B05bPurchaseAddPage, {param1: branchid,  param2: inventoryID});  
  }

  goTo(){
    this.navCtrl.push(B04cInventoryPage);
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });
    this.loading.present();
  }

  clearItem(){
    this.inventoryDesc = "";
    this.branch = "";
  }

  searchItem(){
    this.searchMessage="";
    this.errorMessage="";

    let temp_tbl = [];
    let temp_column = [];
    let temp_value = [];
    this.inventoryItems = [];

    let sortby= "No";
    let sorttype= "No";

    if (this.inventoryDesc!=""){

      if(this.GRP_ID=="1") {            //system admin
        temp_tbl = ["INVENTORY"];
        temp_column = ["ITEM_DESC"];
        temp_value = [this.inventoryDesc];
      }
      else if ((this.GRP_ID == "2") || (this.GRP_ID == "3")) {      //branch admin/ manager
        temp_tbl = ["INVENTORY", "INVENTORY_LEVEL"]; 
        temp_column = ["ITEM_DESC", "BRANCH_ID"];
        temp_value = [this.inventoryDesc, this.BRANCH_ID];
      }
      this.branch="";
    }
    else if (this.branch!=""){
      temp_tbl = ["INVENTORY_LEVEL"];
      temp_column = ["BRANCH_ID"];
      temp_value = [this.branch];
      this.inventoryDesc="";
    }
    else {

      if(this.GRP_ID=="1") {            //system admin
        temp_tbl = ["All"];
        temp_column = ["All"];
        temp_value = ["All"];
      }
      else if ((this.GRP_ID == "2") || (this.GRP_ID == "3")) {      //branch admin/ manager
        temp_tbl = ["INVENTORY_LEVEL"]; 
        temp_column = ["BRANCH_ID"];
        temp_value = [this.BRANCH_ID];
      }
    }

    let tbl = temp_tbl;
    let column = temp_column;
    let value = temp_value;
    
    let tblkey = ["BRANCH_ID", "INVENTORY_ID"];
    let fktbl = ["BRANCH", "INVENTORY"];
    let fkkey = ["BRANCH_ID", "INVENTORY_ID"];
  
    let jsonsort = this.serviceapi.sort(sortby,sorttype);
    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonsort,jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();
    console.log(json_data);
    this.serviceapi.readdata(json_data,"INVENTORY_LEVEL","1","1").then((result) => {
      this.loading.dismiss();
      this.Status = result["Message"];
      if (this.Status == '1'){
        
        let Records = result["Records"];
        this.inventoryArr = Records;
        this.inventoryItems = this.inventoryArr;
        
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
    
  }
}



// WEBPACK FOOTER //
// ./src/pages/b04-inventory-management/b04-inventory-management.ts